export const InsightAppIds = {
  'dev': '600a1ad0-063f-45b2-8a90-94a773252b76'
};
